site.searchBox = {
	init: function () {
		var $body = $('body'),
			$s = $('#searchBox, #mSearchBox'),
			$menu = $('#mainmenu .mmLevel1');

		$menu.append('<li class="ele-search level1" id="searchToggle"><a class="searchLink"><i class="fas fa-search"></i></a></li>');

		$s.on('click touchstart', function (e) {
			e.stopPropagation();
		});

		$('#searchToggle, #msearchToggle').on('click touchstart', function (e) {
			e.preventDefault();
			e.stopPropagation();

			$body.toggleClass('search-open');

			$('body.search-open').on('click touchstart', function () {
				site.searchBox.close(true);
			});

			if ($body.hasClass('search-open')) {
				$('#q').focus();
				$('i', '#searchToggle').removeClass('fa-search').addClass('fa-times');
			}
			else {
				site.searchBox.close(true);
			}
			return true;
		});
		$(window).scroll(function () {
			site.searchBox.close(true);
		});
		// $('#mainmenu li').hover(function() {
		// 	$('body').removeClass('search-open');
		// })
	},

	close: function (closing) {
		closing = closing || false;
		var $body = $('body');

		if (!closing && !$body.hasClass('search-open')) return;

		$body.removeClass('search-open');
		$('i', '#searchToggle').removeClass('fa-times').addClass('fa-search');

		if (closing) {
			$body.addClass('search-closing');
			setTimeout(function () {
				$('body').removeClass('search-closing');
			}, 500);
		}
	},
};

site.inits.push('site.searchBox.init()');
